<div class="footer">
	<div class="left">
		<div class="description" [ngSwitch]="activeConfig ? 'active' : 'inactive'">
			<ng-container *ngSwitchDefault>
				<div class="info-box">
					<span class="white-box line-height">
						<mat-icon svgIcon="sort_arrow_up"></mat-icon>
					</span>
					<span class="white-box line-height">
						<mat-icon svgIcon="sort_arrow_down"></mat-icon>
					</span>
					<p class="text">{{ 'action_center_navigate' | translate }}</p>
				</div>
				<div class="info-box">
					<span class="white-box line-height"> ENTER </span>
					<p class="text">{{ 'action_center_select' | translate }}</p>
				</div>
			</ng-container>
			<ng-container *ngSwitchCase="'active'">
				<div class="info-box">
					<span class="white-box">
						<mat-icon class="rotate" svgIcon="arrow_dropdown"></mat-icon>
					</span>
					<p class="text">{{ 'action_center_back' | translate }}</p>
				</div>
				<div class="info-box" *ngIf="!activeConfig.autoEnter">
					<span class="white-box line-height"> ENTER </span>
					<p class="text">{{ 'action_center_apply' | translate }}</p>
				</div>
			</ng-container>
			<div class="info-box">
				<span class="white-box line-height"> ESC </span>
				<button class="text" tabindex="-1" mat-button (click)="closeDialog.emit()">
					{{ 'close' | translate }}
				</button>
			</div>
		</div>
	</div>
	<div class="right">
		<div class="description">
			<div *ngIf="activeConfig && !activeConfig.autoEnter">
				<button
					mat-flat-button
					(click)="applyAction.emit()"
					[disabled]="!enableApplyBtn()"
				>
					{{ 'action_center_apply' | translate | uppercase }}
				</button>
			</div>
			<div class="info-box" *ngIf="activeConfig && activeConfig.autoEnter">
				<span class="white-box line-height"> ENTER </span>
				<p class="text">{{ 'action_center_apply' | translate }}</p>
			</div>
		</div>
	</div>
</div>
